var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-3 -4 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.667.667C.931.667.334 1.264.334 2v8c0 .737.597 1.334 1.333 1.334h10.667c.737 0 1.333-.597 1.333-1.334V2c0-.736-.596-1.333-1.333-1.333H1.667Zm0 1.333h10.667v.668L7.001 6 1.667 2.668V2Zm0 2.002 5.334 3.332 5.333-3.332V10H1.667V4.002Z",
    fill: "currentColor"
  })));
}
export default SvgEmailreact;